import { useQuery } from "@tanstack/react-query";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export const useStaticRoutes = (
  terminalCode: number | undefined,
  search: string,
  trackingSearch: string,
  filter: string,
  isEnabled: boolean = true
) => {
  const { data: routeDetails, isLoading: isLoadingRouteDetails, refetch: refetchRouteDetails } =
    useQuery({
      // Keep filter in cache key so each tab ("all", "atRisk", "late") has its own query.
      queryKey: [QUERY_KEYS.GET_STATIC_ROUTES, terminalCode, search, trackingSearch, filter],
      queryFn: async () => {
        const params = new URLSearchParams();
        if (terminalCode) { 
          params.set("terminalCode", terminalCode.toString()); 
        }

        if (search) {
          params.set("search", search.toString());
        }

        if (trackingSearch) {
          params.set("trackingSearch", trackingSearch.toString());
        }

        if (filter) {
          params.set("filter", filter.toString());
        }

        const response = await apiQueryAdapter.query(
          `/pickups/unassigned/grouped-by-static-route`,
          "GET",
          { params }
        );
        return response;

      },
      refetchOnWindowFocus: false,
      enabled: !!terminalCode && isEnabled,
      retry: false,
    })
  return { routeDetails, isLoadingRouteDetails, refetchRouteDetails };
}